import { z } from 'zod'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const streetTypeSuggestionsSchema = z.array(
  z.object({
    value: z.string(),
  })
)

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const suburbStateSuggestionsSchema = z.array(
  z.object({
    value: z.string(),
  })
)

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const countryListSchema = z.array(
  z.object({
    code: z.string(),
    description: z.string(),
  })
)

export const addressSchema = z.object({
  unitNumber: z.string().optional(),
  streetNumber: z.string(),
  streetName: z.string(),
  streetType: z.string(), // Road, Avenue, etc
  suburb: z.string(),
  postcode: z.string(),
  state: z.string(),
  country: z.union([z.literal('Australia'), z.string()]),
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const addressSuggestionsSchema = z.array(
  z.object({
    id: z.string(),
    value: z.string(),
  })
)

export type AddressSuggestions = z.infer<typeof addressSuggestionsSchema>
export type AccountHolderAddress = z.infer<typeof addressSchema>
export type CountryList = z.infer<typeof countryListSchema>
export type SuburbStateSuggestions = z.infer<typeof suburbStateSuggestionsSchema>
export type StreetTypeSuggestions = z.infer<typeof streetTypeSuggestionsSchema>
